import { prismicService } from '@services/businessContainer';
import { injectLayoutData } from '@utils/layout';
import { NextSeo } from 'next-seo';
import React from 'react';
import { formatPrismicData } from '@monofront/business/utils';
import { GetServerSideProps } from 'next';
import { ICustomPageProps } from '../landing-page';
import Table from '@features/Qa/Table';
import Link from 'next/link';
import Arrow from '@monofront/design-system/visuals/Icons/Arrow';

type PageProps = ICustomPageProps<'page'>;

const Pages = ({ page }: PageProps) => {
  return (
    <div className="tw-mx-4">
      <NextSeo noindex={true} nofollow={true} />
      <Link href="/qa" legacyBehavior>
        <div className="tw-lf-link-md tw-mb-4 tw-flex tw-items-center tw-space-x-2">
          <Arrow color="blue" headDirection="left" width={9} height={15} />
          <p className="tw-text-blue-600">{'Back'}</p>
        </div>
      </Link>
      <Table customPage={page} pageType={'Page'} />
    </div>
  );
};

export const getServerSideProps = injectLayoutData<
  PageProps,
  GetServerSideProps<PageProps>
>(async () => {
  const page = await prismicService.getDocumentsByCustomTypeName(
    'page',
    undefined,
  );

  if (!page)
    return {
      notFound: true,
    };

  return {
    props: {
      page: formatPrismicData(page.results),
    },
  };
});

export default Pages;
